import React from "react";
import trans from "../../../../utils";
import POIsContactInfo from "./POIsContactInfo";
import POIsWorkingInfo from "./POIsWorkingInfo";

export default function POIsContact({ addPOI }) {
	return (
		<>
			<div className="d-flex align-items-center">
				<p className="fs-16 fw-500 brand-700 text-capitalize me-2">
					{trans("contact info")}
				</p>
				<p style={{ textTransform: "capitalize", color: "#42526E" }}>
					({trans("optional")})
				</p>
			</div>
			<POIsContactInfo addPOI={addPOI} />
			<POIsWorkingInfo addPOI={addPOI} />
		</>
	);
}
